import React, { useState, useRef } from "react";
import {
  Box,
  FormLabel,
  TextField,
  Button,
  Typography,
  Link,
  InputAdornment,
  IconButton,
} from '@mui/material';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import ForgetPasswordApi from "../../api/forget_password/forget_password.ts";
import { UserPasswordSuccessAlert } from "../alert/userAlert";

const ForgetPassword = () => {

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: '',
    new_password: '',
    confirm_password: '',
  })

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);

  const handleSubmit = (e) => {
    e.preventDefault();

    if ((formData.new_password.length === formData.confirm_password.length) === false) {
      UserPasswordSuccessAlert('Las contraseñas no tiene la misma longitud.', '#d32f2f');
      return;
    }

    if (formData.new_password !== formData.confirm_password) {
      UserPasswordSuccessAlert('Las contraseñas no son iguales.', '#d32f2f');
      return;
    }

    const response = ForgetPasswordApi(formData);

    if (response.status !== 200) {
      setFormData({ new_password: '', confirm_password: '' });
      UserPasswordSuccessAlert('Contraseña actualizada exitosamente.', '#1976d2');
    }

  };

  return (
    <Box component="section" className="box-login" boxShadow={3}>
      <Typography variant="h5" component="h1" gutterBottom>
        Recuperar Contraseña
      </Typography>

      <Box component="form" sx={{ width: '100%', mt: 1 }}>

        <FormLabel htmlFor="email-input" sx={{ mb: 1, display: 'block', fontSize: 20 }}>
          Correo Electrónico
        </FormLabel>
        <TextField
          required
          fullWidth
          id="email-input"
          type="email"
          autoComplete="email"
          placeholder="Z3kxu@example.com"
          margin="normal"
          variant="outlined"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />

        <FormLabel htmlFor="new_password-input" sx={{ mb: 1, display: 'block', fontSize: 20 }}>
          Nueva Contraseña
        </FormLabel>
        <TextField
          required
          fullWidth
          id="new_password-input"
          type={showPassword ? 'text' : 'password'}
          value={formData.new_password}
          onChange={(e) => setFormData({ ...formData, new_password: e.target.value })}
          placeholder="********"
          margin="normal"
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={showPassword ? 'ocultar contraseña' : 'mostrar contraseña'}
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <FormLabel htmlFor="confirm-password-input" sx={{ mb: 1, display: 'block', mt: 2, fontSize: 20 }}>
          Confirmar Nueva Contraseña
        </FormLabel>
        <TextField
          required
          fullWidth
          id="confirm-password-input"
          type={showConfirmPassword ? 'text' : 'password'}
          value={formData.confirm_password}
          onChange={(e) => setFormData({ ...formData, confirm_password: e.target.value })}
          placeholder="********"
          margin="normal"
          variant="outlined"

          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={showConfirmPassword ? 'ocultar contraseña' : 'mostrar contraseña'}
                  onClick={handleClickShowConfirmPassword}
                  edge="end"
                >
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2, fontSize: 20 }}
          disabled={!formData.email || !formData.new_password || !formData.confirm_password}
          onClick={handleSubmit}
        >
          Guardar Cambios
        </Button>

        <Box sx={{ display: 'flex', justifyContent: 'center', fontSize: 18 }}>
          <Link href="/" underline="hover">
            Volver al Inicio de Sesión
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default ForgetPassword;